import { buildApiUrl } from '../config/appConfig';

export interface RagUploadResponse {
  message: string;
  documentId: string;
  fileName: string;
  chunkCount: number;
  storeStats: {
    documentCount: number;
    chunkCount: number;
  };
}

export interface RagCitation {
  id: string;
  fileName: string;
  chunkIndex: number;
  score: number;
  excerpt: string;
}

export interface RagQueryResponse {
  answer: string;
  citations: RagCitation[];
}

export async function uploadRagDocument(file: File): Promise<RagUploadResponse> {
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(buildApiUrl('/rag/upload'), {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const errorPayload = await response.json().catch(() => null);
    throw new Error(errorPayload?.error || 'Failed to upload document.');
  }

  return response.json();
}

export async function queryRag(question: string): Promise<RagQueryResponse> {
  const response = await fetch(buildApiUrl('/rag/query'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ question }),
  });

  if (!response.ok) {
    const errorPayload = await response.json().catch(() => null);
    throw new Error(errorPayload?.error || 'Failed to query indexed documents.');
  }

  return response.json();
}
